import { useCustomClient } from '@uag/react-core';
import { AxiosError, AxiosRequestConfig, create } from 'axios';

const welcomeApiClient = create({
    baseURL: import.meta.env.VITE_APP_API_URL,
});

export type ErrorType<Error> = AxiosError<Error>;

export const useCustomWelcomeClient = <T,>(): ((config: AxiosRequestConfig) => Promise<T>) =>
    useCustomClient<T>(true, welcomeApiClient);
